/* eslint-disable */
/* global $, data, query_string */
import * as d3 from 'd3'
import _ from 'underscore'
import table from 'bam-node-savant-table/table'
import * as d3Annotate from 'd3-svg-annotation'

const { guff } = require('bam-node-baseball-savant/utils/guff')

let ticking = false
let isFixedHeaderShowing = false
const tableDivId = 'jump_table'

$(document).ready(() => {
    if (query_string.sortDir) {
        $('#sortDir').val(query_string.sortDir)
    }

    if (query_string.sort) {
        $('#sort').val(query_string.sort)
    }

    createJumpChart({
        id: 'jump_chart',
    })

    $('form').submit(false)

    if (data && data.length > 0) {
        let dataLoad = data
        if (query_string.team) {
            dataLoad = _.filter(
                dataLoad,
                (d) => d.name_abbrev === query_string.team
            )
        }
        const type = $('#ddlType').val()

        const headers = [
            {
                name: 'Fielder',
                field: 'href',
                customSortField: 'name_display_last_first',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
                photoId: 'resp_fielder_id',
            },
            {
                name: 'Team',
                field: 'name_abbrev',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                photo: '<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" />',
                photoId: 'team_id',
                photoOnly: true,
            },
            {
                name: 'Outs',
                field: 'n_outs',
                type: 'number',
                headerClass: 'th-component-header  border-left',
                fieldClass: 'tr-data  border-left',
            },
            {
                name: 'Opp',
                field: 'n',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: '%',
                field: 'outs_per_play',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: (val) => guff(val, 'jump_out_percent'),
            },

            {
                name: 'OAA',
                field: 'outs_above_average',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: 'Reaction',
                field: 'rel_league_reaction_distance',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data border-left',
                displayFn: (val) => guff(val, 'outfield_jump'),
            },
            {
                name: 'Burst',
                field: 'rel_league_burst_distance',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: (val) => guff(val, 'outfield_jump'),
            },
            {
                name: 'Route',
                field: 'rel_league_routing_distance',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: (val) => guff(val, 'outfield_jump'),
            },
            {
                name: 'Feet vs Avg',
                field: 'rel_league_bootup_distance',
                type: 'number',
                headerClass: 'th-component-header  border-left',
                fieldClass: 'tr-data  border-left',
                highlight: [-5, 0, 5],
                displayFn: (val) => guff(val, 'outfield_jump'),
            },
            {
                name: 'Feet Covered',
                field: 'f_bootup_distance',
                type: 'number',
                headerClass: 'th-component-header  border-right',
                fieldClass: 'tr-data border-right',
                displayFn: (val) => guff(val, 'outfield_jump'),
            },
        ]

        const width = $(`#${tableDivId}`).outerWidth()
        let repeatHeaders = false
        if (width <= 768) {
            repeatHeaders = 15
        }
        const t = new table({
            id: 'jump_table',
            repeatHeader: repeatHeaders,
            secondaryHeaders: [
                {
                    name: '',
                    colspan: 3,
                    headerClass: 'th-name-header',
                },
                {
                    name: '2+ Stars (0-90%)',
                    colspan: 4,
                    headerClass: 'th-title-header ',
                },
                {
                    name: 'Components of Jump (vs Avg)',
                    colspan: 3,
                    headerClass: 'th-title-header',
                },
                {
                    name: 'Jump',
                    colspan: 2,
                    headerClass: 'th-title-header',
                },
            ],
            headers,
            data: dataLoad,
            defaultSort:
                headers[Number($('#sort').val())].customSortField ||
                headers[Number($('#sort').val())].field,
            defaultSortDirection: $('#sortDir').val(),
            sortClass: 'column-sort',
            showRank: true,
        })
    } else {
        $('#NoData').html('<h1>No Data Found.</h2>')
    }

    $('#btnUpdate').click(() => {
        window.location.href = `/leaderboard/outfield_jump?year=${$(
            '#ddlSeason'
        ).val()}&min=${$('#ddlMin').val()}`
    })
    $('#btnCSV').click(() => {
        window.location.href = `/leaderboard/outfield_jump?year=${$(
            '#ddlSeason'
        ).val()}&min=${$('#ddlMin').val()}&csv=true`
    })

    $(document).on('click', 'th.th-component-header', function () {
        const id = this.id.split('-')[1]

        if (Number($('#sort').val()) === Number(id)) {
            if ($('#sortDir').val() === 'desc') {
                $('#sortDir').val('asc')
            } else {
                $('#sortDir').val('desc')
            }
        } else {
            $('#sortDir').val('desc')
        }
        $('#sort').val(id)
        isFixedHeaderShowing = false
        checkHeaderPosition(tableDivId)
        populateUrl()
    })

    window.addEventListener('scroll', (e) => {
        if (!ticking && data.length) {
            window.requestAnimationFrame(() => {
                checkHeaderPosition(tableDivId)
                ticking = false
            })

            ticking = true
        }
    })

    function checkHeaderPosition(divId) {
        const scrollPosY = window.scrollY
        const posTop = $(`#${divId}`).offset().top
        const height = $(`#${divId} table thead`).height()
        if (!isFixedHeaderShowing && posTop < scrollPosY) {
            isFixedHeaderShowing = true
            addStaticHeader(divId)
        } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
            $(`#${divId} table thead`).removeClass('fixed-header')
            isFixedHeaderShowing = false
        }
    }

    function addStaticHeader(divId) {
        const width = $(`#${divId}`).outerWidth()
        // $(".tr-component-row th").removeClass("column-sort");

        if (width && width > 767) {
            let tableCell = 0

            // Set TH Width before applying fixed-header
            $('.default-table-row')
                .first()
                .children('td')
                .each(function () {
                    const width = $(this).outerWidth()
                    $(`.tr-component-row th:nth-child(${tableCell + 1})`).css(
                        'width',
                        width
                    )
                    tableCell++
                })

            $(`#${divId} table thead`).addClass('fixed-header')
            tableCell = 0

            // Set TD Width before applying fixed-header
            $('.tr-component-row')
                .children('th')
                .each(function () {
                    const width = $(this).outerWidth()
                    $(`.default-table-row td:nth-child(${tableCell + 1})`).css(
                        'width',
                        width
                    )
                    tableCell++
                })
        }
    }

    window.addEventListener('resize', () => {
        if (isFixedHeaderShowing) {
            addStaticHeader(tableDivId)
        }
    })

    function populateUrl() {
        const url = `/leaderboard/outfield_jump?year=${$(
            '#ddlSeason'
        ).val()}&min=${$('#ddlMin').val()}&sort=${$('#sort').val()}&sortDir=${$(
            '#sortDir'
        ).val()}`
        window.history.pushState('', '', url)
        return url
    }
})

function createJumpChart(opts) {
    let size = $('#jump_table').width() || 700

    if (size >= 700) {
        size = 700
    }
    if (size < 330) {
        size = 330
    }

    const divId = opts.id

    const margin = {
        top: size * 0.25,
        right: size * 0.08,
        bottom: size * 0.2,
        left: size * 0.12,
    }
    const width = size - margin.left - margin.right
    const height = size - margin.top - margin.bottom

    let svg = d3
        .select(`#${divId}`)
        .append('svg')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)

    svg.append('rect')
        .attr('width', '100%')
        .attr('height', '100%')
        .style('fill', '#e4f2f5')

    appendTitle()

    svg = svg
        .append('g')
        .attr('transform', `translate(${margin.left},${margin.top - 40})`)

    const x = d3.scaleLinear().domain([-3, 5]).range([0, width])
    const y = d3.scaleLinear().domain([-3, 2]).range([height, 0])
    const fontSize = d3.scaleLinear().range([10, 16]).domain([330, 700])
    const scaleRadius = d3.scaleLinear().range([2, 4]).domain([330, 700])

    const highlightColor = d3
        .scaleLinear()
        .range(['#3661AD', '#ffffff', '#D82129'])
        .domain([-20, 0, 20])

    const highlightJumpColor = d3
        .scaleLinear()
        .range(['#3661AD', '#c2c2c2', '#D82129'])
        .domain([-5, 0, 5])

    function appendOAALegend() {
        svg.append('text')
            .attr('x', width / 2)
            .attr('y', y(-4.5))
            .attr('text-anchor', 'middle')
            .style('fill', '#3a9098')
            .style('font-size', `${fontSize(size)}px`)
            .text('Jump')

        for (let i = -5; i <= 5; i += 1) {
            svg.append('circle')
                .attr('cx', x(1) + i * 25)
                .attr('cy', y(-4.8))
                .attr('fill', highlightJumpColor(i))
                .attr('stroke', '#000')
                .attr('r', scaleRadius(size))

            if (i == -5 || i == 0 || i == 5) {
                svg.append('text')
                    .attr('x', x(1) + i * 25.1)
                    .attr('y', y(-5.1))
                    .style('font-size', `${fontSize(size)}px`)
                    .attr('text-anchor', 'middle')
                    .text(i)
            }
        }
    }
    function loadData() {
        svg.selectAll('dots')
            .data(data)
            .enter()
            .append('circle')
            .attr('cx', (d) => x(Number(d.rel_league_reaction_distance)))
            .attr('cy', (d) => y(Number(d.rel_league_routing_distance)))
            .attr('r', scaleRadius(size))
            .attr('stroke', '#000')
            .attr('fill', (d) =>
                highlightJumpColor(d.rel_league_bootup_distance)
            )
            .on('mouseover', (event, d) => {
                const tooltip = d3
                    .select('body')
                    .append('div')
                    .attr('id', `tooltip_${d.resp_fielder_id}`)
                    .attr('class', 'tooltip')
                    .style('opacity', 1)

                // var html = '<div style="width: 320px; line-height: 1.4rem;"><div style="float: left; width: 70px;"><div class="player-image"><img onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/' + d.resp_fielder_id + '.png" /></div></div><div style="float: left; width: 230px; font-family: \'Roboto Condensed\'; font-size: 14px;"><b><span style=" font-size: 16px;">' + d.name_display_last_first + '</span></b><br/>OAA On 2+ Star Plays: <span style="padding: 1px 3px 1px 3px; background-color: ' + highlightColor(d.outs_above_average) + ';">' + d.outs_above_average + '</span><br/>Burst: <span style="padding: 1px 3px 1px 3px; background-color: ' + highlightJumpColor(d.rel_league_burst_distance) + ';">' + d.rel_league_burst_distance + '</span>Reaction: <span style="padding: 1px 3px 1px 3px; background-color: ' + highlightJumpColor(d.rel_league_reaction_distance) + ';">' + d.rel_league_reaction_distance + '</span>Route: <span style="padding: 1px 3px 1px 3px; background-color: ' + highlightJumpColor(d.rel_league_routing_distance) + ';">' + d.rel_league_routing_distance + '</span><br/><br/><span style="font-size: 16px; font-weight: bold;">Jump:</span> <span style="font-size: 16px; font-weight: bold; padding: 1px 3px 1px 3px; background-color: ' + highlightJumpColor(d.rel_league_bootup_distance) + ';">' + d.rel_league_bootup_distance + '</span></div></div>';
                const html =
                    `<div style="width: 320px; line-height: 1.4rem;">` +
                    `<div style="float: left; width: 70px;"><div class="player-image">` +
                    `<img onError="this.onerror=null;this.src='https://content.mlb.com/images/headshots/current/60x60/generic.png';" src="https://content.mlb.com/images/headshots/current/60x60/${d.resp_fielder_id}.png" />` +
                    `</div>` +
                    `</div>` +
                    `<div style="float: left; width: 230px; font-family: 'Roboto Condensed'; font-size: 14px;">` +
                    `<b><span style=" font-size: 16px;">${d.name_display_last_first}</span></b><br/>` +
                    `OAA On 2+ Star Plays: <span style="padding: 1px 3px 1px 3px; background-color: ${highlightColor(
                        d.outs_above_average
                    )};">${d.outs_above_average}</span>` +
                    `<table><tbody>` +
                    `<tr style="background-color: #efefef"><td>Reaction</td><td><span style="color: ${highlightJumpColor(
                        d.rel_league_reaction_distance
                    )};">${
                        d.rel_league_reaction_distance > 0
                            ? `+${d.rel_league_reaction_distance}`
                            : d.rel_league_reaction_distance
                    }</span></td>` +
                    `<td><span id="reaction"></span></td></tr>` +
                    `<tr style="background-color: #efefef"><td>Burst</td><td><span style="color: ${highlightJumpColor(
                        d.rel_league_burst_distance
                    )};">${
                        d.rel_league_burst_distance > 0
                            ? `+${d.rel_league_burst_distance}`
                            : d.rel_league_burst_distance
                    }</span></td>` +
                    `<td><span id="burst"></span></td></tr>` +
                    `<tr style="background-color: #efefef"><td>Route</td><td><span style="color: ${highlightJumpColor(
                        d.rel_league_routing_distance
                    )};">${
                        d.rel_league_routing_distance > 0
                            ? `+${d.rel_league_routing_distance}`
                            : d.rel_league_routing_distance
                    }</span></td>` +
                    `<td><span id="route"></span></td></tr>` +
                    `<tr style="background-color: #efefef; border-top: solid 1px #c2c2c2;"><td><span style="font-weight: bold;">Jump</span></td><td><span style="font-weight: bold; color: ${highlightJumpColor(
                        d.rel_league_bootup_distance
                    )};">${
                        d.rel_league_bootup_distance > 0
                            ? `+${d.rel_league_bootup_distance}`
                            : d.rel_league_bootup_distance
                    }</span></td>` +
                    `<td><span id="jump"></span></td></tr>` +
                    `</table></div></div>`

                tooltip
                    .html(html)
                    .style('left', `${event.pageX + 5}px`)
                    .style('top', `${event.pageY - 28}px`)

                if (d.percent_rank_rel_league_burst_distance != null) {
                    createBar(
                        'burst',
                        d.percent_rank_rel_league_burst_distance / 100
                    )
                }
                if (d.percent_rank_rel_league_reaction_distance != null) {
                    createBar(
                        'reaction',
                        d.percent_rank_rel_league_reaction_distance / 100
                    )
                }
                if (d.percent_rank_rel_league_routing_distance != null) {
                    createBar(
                        'route',
                        d.percent_rank_rel_league_routing_distance / 100
                    )
                }
                if (d.percent_rank_rel_league_bootup_distance != null) {
                    createBar(
                        'jump',
                        d.percent_rank_rel_league_bootup_distance / 100
                    )
                }
            })
            .on('mouseout', (event, d) => {
                d3.select(`#tooltip_${d.resp_fielder_id}`).style('opacity', 0)
                $(`#tooltip_${d.resp_fielder_id}`).hide()
                $(`#tooltip_${d.resp_fielder_id}`).remove()
            })
    }
    function addAxes() {
        // Add the x Axis
        const xAxes = svg
            .append('g')
            .attr('transform', `translate(0,${height})`)
            .call(d3.axisBottom(x).ticks(8).tickPadding(10).tickSize(-height))

        xAxes.selectAll('text').style('font-size', `${fontSize(size)}px`)
        // text label for the x axis
        svg.append('text')
            .attr('transform', `translate(${width / 2} ,${y(-3.85)})`)
            .style('text-anchor', 'middle')
            .style('font-size', `${fontSize(size)}px`)
            .text('Reaction')

        // Add the y Axis
        const yAxes = svg
            .append('g')
            .call(d3.axisLeft(y).ticks(6).tickPadding(10).tickSize(-width))

        yAxes.selectAll('text').style('font-size', `${fontSize(size)}px`)

        // text label for the y axis
        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - margin.left + 20)
            .attr('x', 0 - height / 2)
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('font-size', `${fontSize(size)}px`)
            .text('Route')
    }

    function appendTitle() {
        svg.append('text')
            .attr('x', size / 2)
            .attr('y', size / 13)
            .attr('text-anchor', 'middle')
            .style('font-size', `${size / 35}px`)
            .text('Feet Saved or Lost on Outfield Plays')

        svg.append('text')
            .attr('x', size / 2)
            .attr('y', size / 8.8)
            .attr('text-anchor', 'middle')
            .style('font-size', `${size / 35}px`)
            .text('Due to Reaction and Route')
    }

    function addLines() {
        // X AXIS
        svg.append('line')
            .attr('x1', x(-2.68))
            .attr('x2', x(0.45))
            .attr('y1', y(-3.8))
            .attr('y2', y(-3.8))
            .attr('stroke', '#569DA5')

        svg.append('text')
            .attr('x', x(-2.78))
            .attr('y', y(-3.87))
            .attr('font-size', fontSize(size))
            .attr('fill', '#569DA5')
            .text('◀')

        svg.append('text')
            .attr('x', x(-1.25))
            .attr('y', y(-4.15))
            .attr('fill', '#3661AD')
            .style('font-size', fontSize(size))
            .text('Slow')

        svg.append('line')
            .attr('x1', x(1.58))
            .attr('x2', x(4.55))
            .attr('y1', y(-3.8))
            .attr('y2', y(-3.8))
            .attr('stroke', '#569DA5')

        svg.append('text')
            .attr('x', x(4.5))
            .attr('y', y(-3.87))
            .style('font-size', fontSize(size))
            .attr('fill', '#569DA5')
            .text('▶')

        svg.append('text')
            .attr('x', x(2.9))
            .attr('y', y(-4.15))
            .attr('fill', '#D82129')
            .style('font-size', fontSize(size))
            .text('Quick')

        // Y AXIS
        svg.append('line')
            .attr('x1', x(-3.65))
            .attr('x2', x(-3.65))
            .attr('y1', y(0))
            .attr('y2', y(1.7))
            .attr('stroke', '#569DA5')

        svg.append('text')
            .attr('x', x(-3.75))
            .attr('y', y(1.7))
            .attr('font-size', fontSize(size))
            .attr('fill', '#569DA5')
            .text('▲')

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', x(-3.85))
            .attr('x', y(3.2))
            .style('text-anchor', 'middle')
            .attr('fill', '#D82129')
            .style('font-size', fontSize(size))
            .text('Direct')

        svg.append('line')
            .attr('x1', x(-3.65))
            .attr('x2', x(-3.65))
            .attr('y1', y(-1))
            .attr('y2', y(-2.8))
            .attr('stroke', '#569DA5')

        svg.append('text')
            .attr('x', x(-3.75))
            .attr('y', y(-2.8))
            .attr('font-size', fontSize(size))
            .attr('fill', '#569DA5')
            .text('▼')

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', x(-3.8))
            .attr('x', y(5.9))
            .style('text-anchor', 'middle')
            .style('font-size', fontSize(size))
            .attr('fill', '#3661AD')
            .text('Indirect')

        // League Avg Line
        svg.append('line')
            .attr('x1', x(-2))
            .attr('y1', y(2))
            .attr('x2', x(3))
            .attr('y2', y(-3))
            .attr('stroke', '#569DA5')

        if (size >= 700) {
            // Annotate
            const annotations = [
                {
                    type: d3Annotate.annotationCalloutCircle,
                    note: { label: 'Average Line' },
                    x: x(2.2),
                    y: y(-2.2),
                    dy: 40,
                    dx: -76,
                    subject: { radius: 10, radiusPadding: 0 },
                },
                {
                    //        type: d3.annotationCalloutCircle,
                    note: { label: 'Slow Reaction & Indirect Route' },
                    x: x(-1.5),
                    y: y(-1.5),
                    dy: 65,
                    dx: -1,
                    subject: { radius: 10, radiusPadding: 0 },
                    color: '#3661AD',
                },
                {
                    //        type: d3.annotationCalloutCircle,
                    note: { label: 'Quick Reaction & Direct Route' },
                    x: x(3.5),
                    y: y(0.5),
                    dy: -65,
                    dx: 1,
                    subject: { radius: 10, radiusPadding: 0 },
                    color: '#D82129',
                },
            ]

            const annotate = d3Annotate.annotation().annotations(annotations)

            svg.append('g').attr('class', 'annotation-group').call(annotate)
        }
    }

    addAxes()
    addLines()
    appendOAALegend()
    loadData()
}

function createBar(id, percent) {
    d3.select(`#${id}`).html('')

    const margin = { top: 0, right: 10, bottom: 0, left: 10 }
    var width = 100 - margin.left - margin.right
    var height = 20 - margin.top - margin.bottom

    const highlightColor = d3
        .scaleLinear()
        .range(['#3661AD', '#ffffff', '#D82129'])
        .domain([0, 0.5, 1])

    /*    if (serverVals.playerPosition === '1') {
        var highlightColor = d3.scaleLinear().range(['#D82129', '#ffffff', '#3661AD']).domain([0,.5,1]);
    } */

    var width = 100
    var height = 20
    // Feel free to change or delete any of the code you see in this editor!
    const svg = d3
        .select(`#${id}`)
        .append('svg')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)
        .append('g')
        .attr('transform', `translate(${margin.left},${margin.top})`)

    const x = d3.scaleLinear().range([0, width]).domain([0, 1])
    svg.append('line')
        .attr('x1', 0)
        .attr('x2', width)
        .attr('y1', height / 2)
        .attr('y2', height / 2)
        .attr('stroke', '#9b9b9b')
        .attr('stroke-width', '3px')

    svg.append('circle')
        .attr('cx', x(0.5))
        .attr('cy', height / 2)
        .attr('r', 3)
        .attr('fill', '#9b9b9b')
        .attr('stroke', '#9b9b9b')

    if (percent >= 0 && percent <= 100) {
        svg.append('circle')
            .attr('cx', x(percent))
            .attr('cy', height / 2)
            .attr('r', 6)
            .attr('fill', highlightColor(percent)) // '#3a9098')//
            .attr('stroke', '#000')
            .on('mouseover', (event, d) => {
                const tooltip = d3
                    .select('body')
                    .append('div')
                    .attr('id', `tooltip_${id}`)
                    .attr('class', 'bar-tooltip')
                    .style('opacity', 1)

                const html = `<div style="background-color: #ffffff; border: solid 1px #000; padding: 5px;">${suffix.ordinalSuffix(
                    (percent * 100).toFixed(0)
                )} percentile</div>`

                tooltip
                    .html(html)
                    .style('left', `${event.pageX + 5}px`)
                    .style('top', `${event.pageY - 28}px`)
            })
            .on('mouseout', (d) => {
                d3.select(`#tooltip_${id}`).style('opacity', 0)
                $(`#tooltip_${id}`).hide()
                $(`#tooltip_${id}`).remove()
            })
    } else {
        svg.append('circle')
            .attr('cx', x(1))
            .attr('cy', height / 2)
            .attr('r', 3)
            .attr('fill', '#9b9b9b')
            .attr('stroke', '#9b9b9b')

        svg.append('circle')
            .attr('cx', x(0))
            .attr('cy', height / 2)
            .attr('r', 3)
            .attr('fill', '#9b9b9b')
            .attr('stroke', '#9b9b9b')
    }
}

document.querySelectorAll('#leaderboard .form-control').forEach((el) => {
    el.addEventListener('change', (e) => {
        const id = el.getAttribute('id')
        const type = id.slice(3)
        const { selectedIndex } = e.target
        document.querySelector(`.label-change-${type}`).innerText =
            e.target[selectedIndex].text
    })
})
